import React, { useEffect } from "react"
import { Link } from "gatsby"
import { useState } from "react"
import PropTypes from "prop-types"
import Image from "./Image"
import ModuleComponent from "../templates/ModuleComponent"

const Header = props => {
  const data = props.data

  const [showMenu, setShowMenu] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const links = data.links
 
  const components = data.components

  const toggleMenu = (e, preventDefault) => {
    if (preventDefault) e.preventDefault()

    if (!showMenu) {
      setShowMenu(true)
      document.getElementById("sidebar").classList.add("side-menu")
      document.getElementById("menuToggle").classList.add("close")
    } else {
      setShowMenu(false)
      document.getElementById("sidebar").classList.remove("side-menu")
      document.getElementById("menuToggle").classList.remove("close")
    }
  }

  const handleScroll = () => {
    if (window && document.documentElement.scrollTop > 50) {
      if (!scrolled) {
        document.getElementById("header").classList.add("scrolled")
        setScrolled(true)
      }
    } else {
      setScrolled(false)
      document.getElementById("header").classList.remove("scrolled")
    }
  }

  /** component did mount */
  useEffect(() => {
    window.addEventListener(`scroll`, handleScroll)
    /** component did unmount */
    return () => {
      window.removeEventListener(`scroll`, handleScroll)
    }
    // eslint-disable-next-line
  }, [])

  return (
    <div id="header" className={props.className}>
      <div id="logo-placeholder">
        {data.logoImage && (
          <Link to="/">
            <Image className="logo" alt="logo" src={data.logoImage} optimized />
          </Link>
        )}
      </div>

      <Link
        to="/"
        className="menu-icon"
        id="menuToggle"
        onClick={e => toggleMenu(e, true)}
      >
        <span></span>
      </Link>

      <nav id="sidebar" className="navbar show-menu">
        <ul>
          {/** links */}
          {links &&
            links.map(link => (
              <li key={link.id}>
                <Link onClick={toggleMenu} to={link.href}>
                  {link.description}
                </Link>
              </li>
            ))}

          {/** components */}
          {components &&
            components.map(item => (
              <li key={item.id}>
                <ModuleComponent
                  id={item.id}
                  module={item.component}
                  {...item.props}
                />
              </li>
            ))}
        </ul>
      </nav>
    </div>
  )
}

Header.propTypes = {
  data: PropTypes.object.isRequired,
}

export default Header
